export default "__VITE_ASSET__ae350930__"